import { render, staticRenderFns } from "./building.vue?vue&type=template&id=4c15a503"
import script from "./building.ts?vue&type=script&lang=js&external"
export * from "./building.ts?vue&type=script&lang=js&external"
import style0 from "./building.vue?vue&type=style&index=0&id=4c15a503&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports